// extracted by mini-css-extract-plugin
module.exports = {"price":"_1ZVK-WnvIjmbUPRxOCBFQC","button":"_11W5zOCypddQ7ph1AZaAwH"};